export default __webpack_public_path__ + "static/media/bl11.5798df37.png";